import { render, staticRenderFns } from "./license-config.vue?vue&type=template&id=f165215c&scoped=true"
import script from "./license-config.vue?vue&type=script&lang=js"
export * from "./license-config.vue?vue&type=script&lang=js"
import style0 from "./license-config.vue?vue&type=style&index=0&id=f165215c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f165215c",
  null
  
)

export default component.exports